import FeatureLayer = require("esri/layers/FeatureLayer");
import Field = require("esri/layers/support/Field");
import LabelClass = require("esri/layers/support/LabelClass");
import SimpleRenderer = require("esri/renderers/SimpleRenderer");
import { PictureMarkerSymbol, TextSymbol } from "esri/symbols";

const pinSymbol = new PictureMarkerSymbol({
  yoffset: 10,
  xoffset: 2,
  // url: "https://static.arcgis.com/images/Symbols/Basic/RedShinyPin.png",
  url: "./assets/RedShinyPin.png",
  width: 32,
  height: 32
});

const pinRenderer = new SimpleRenderer({
  symbol: pinSymbol
});

const graphics = [
  {
    // geometry: new Point({latitude: 40.0, longitude: -90.0}),
    attributes: { ObjectID: 1, Label: "Label" }
  }
];

const pinLabelClass = new LabelClass({
  labelExpressionInfo: { expression: "$feature.Label" },
  labelPlacement: "center-right",
  symbol: new TextSymbol({
    color: "red",
    xoffset: -10,
    haloSize: 1,
    haloColor: "white",
    font: {
      // autocasts as new Font()
      size: 12
    }
  })
});

const pinFields = [
  new Field({
    name: "ObjectID",
    alias: "ObjectID",
    type: "oid"
  }),
  new Field({
    name: "Label",
    alias: "Label",
    type: "string"
  })
];

export const pinLayer = new FeatureLayer({
  id: "pinLayer",
  title: "Push Pins",
  source: graphics,
  fields: pinFields,
  outFields: ["Label"],
  objectIdField: "ObjectID",
  renderer: pinRenderer,
  labelingInfo: [pinLabelClass],
  spatialReference: { wkid: 3785 },
  geometryType: "point",
  legendEnabled: false,
  listMode: "hide"
});
